import type { ProjectItemTarget } from "@/components/layout/cross-project-navigation";
import type { HubResult } from "@/components/panels/search-modal/hub-types";
import type { SettingsPageId } from "@/components/settings/settings-navigation";

export interface HubNavigationHandlers {
  openProject: (projectId: string) => void;
  openFrame: (frame: ProjectItemTarget) => void;
  openTask: (task: ProjectItemTarget) => void;
  openAgent: (agent: ProjectItemTarget & { templateId: string }) => void;
  openMemory: (nodeId: string) => void;
  openSetting: (page: SettingsPageId) => void;
}

/** Route one hub result to its destination; chats open inside the hub. */
export function navigateGlobalSearchResult({
  result,
  handlers,
}: {
  result: HubResult;
  handlers: HubNavigationHandlers;
}): boolean {
  const target: ProjectItemTarget = {
    id: result.id,
    projectId: result.projectId,
    projectName: result.projectName,
  };
  switch (result.kind) {
    case "project":
      handlers.openProject(result.id);
      return true;
    case "frame":
      handlers.openFrame(target);
      return true;
    case "task":
      handlers.openTask(target);
      return true;
    case "agent":
      handlers.openAgent({ ...target, templateId: result.templateId });
      return true;
    case "memory":
      handlers.openMemory(result.id);
      return true;
    case "setting":
      handlers.openSetting(result.page);
      return true;
    case "chat":
      return false;
  }
}
